import React from 'react';
import Modal from './Modal';
import PrimaryButton from './PrimaryButton';
import { useLang } from '../context/LangContext';

interface LoginRequiredModalProps {
  isOpen: boolean;
  onClose: () => void;
  onLogin: () => void;
}

// 국제화 텍스트
const loginRequiredTexts = {
  ko: {
    header: '로그인이 필요합니다',
    body: '회원가입 또는 로그인 후\n이용하실 수 있습니다',
    loginButton: '로그인 하기'
  },
  en: {
    header: 'Login Required',
    body: 'You can use this service after\nsigning up or logging in',
    loginButton: 'Go to Login'
  }
};

const LoginRequiredModal: React.FC<LoginRequiredModalProps> = ({
  isOpen,
  onClose,
  onLogin
}) => {
  const { lang } = useLang();
  const texts = loginRequiredTexts[lang];

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      header={texts.header}
      bgColor="white"
      body={texts.body}
      footer={
        <PrimaryButton onClick={onLogin}>
          {texts.loginButton}
        </PrimaryButton>
      }
    />
  );
};

export default LoginRequiredModal;
